const request: App.I18n.Schema['translation']['request'] = {
  logout: 'Logout user after request failed',
  logoutMsg: 'User status is invalid, please log in again',
  logoutWithModal: 'Pop up modal after request failed and then log out user',
  logoutWithModalMsg: 'User status is invalid, please log in again',
  refreshToken: 'The requested token has expired, refresh the token',
  tokenExpired: 'The requested token has expired'
};

export default request;
